import { SxProps } from '@mui/material';
import { useField } from 'formik';
import { ReactNode } from 'react';

import { BaseRadioButtonGroup, type RadioValue } from 'modules/common/components/MUI/Base/BaseRadioButtonGroup';

interface CheckboxButtonGroupProps {
    options: {
        label: ReactNode | string;
        description?: string;
        value: RadioValue;
    }[];
    name: string;
    direction?: 'row' | 'column';
    disabled?: boolean;
    sx?: SxProps;
    onChange?: (value: RadioValue[]) => void;
}

/** Multi-select toggle group with Checkboxes styled as buttons. Must be used within a Formik form. */
export default function CheckboxButtonGroup({
    name,
    options,
    direction = 'row',
    disabled,
    sx,
    onChange,
}: CheckboxButtonGroupProps) {
    const [field, meta] = useField<RadioValue[]>(name);
    const showError = meta.touched && !!meta.error;

    return (
        <BaseRadioButtonGroup
            multiple
            options={options}
            value={field.value}
            onChange={(newValue) => {
                field.onChange({ target: { name, value: newValue } });
                onChange?.(newValue);
            }}
            name={name}
            direction={direction}
            disabled={disabled}
            error={showError}
            errorMessage={showError ? meta.error : undefined}
            sx={sx}
        />
    );
}
